import React from "react";
import { Fab, Tooltip } from "@mui/material";
import { Logout } from "@mui/icons-material";

export default function PATUpButton(props) {
	const { onClick, disabled, size, tooltipText } = props;

	return (
		<Tooltip title={tooltipText || "Up"}>
			<Fab
				size="small"
				disabled={disabled}
				color="secondary"
				aria-label="up"
				className={props.className ? props.className : ""}
				onClick={onClick}
			>
				<Logout style={{ fontSize: size }} />
			</Fab>
		</Tooltip>
	);
}
